// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about {
  padding: 20px;
  max-width: 1250px;
  margin: 0 auto;
}
.about h2 {
  font-size: 32px;
  line-height: 38px;
  font-weight: 600;
  text-align: center;
  color: #ffffff;
}
@media (min-width: 495px) {
  .about h2 {
    font-size: 48px;
    line-height: 72px;
  }
}
@keyframes rotate360 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.about .imgCard {
  width: 300px;
  height: 250px;
  background: linear-gradient(180deg, #1b242b 0%, #171c1f 100%);
}
.about .imgCard img {
  width: 100%;
  height: 100%;
}
.about .rotate img {
  animation: rotate360 50s linear infinite;
  animation-delay: 2s;
}
@media (min-width: 992px) {
  .about .imgCard {
    width: 398px;
    height: 432px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/About/about.scss","webpack://./src/components/About/about.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;EACA,cAAA;ACCF;ADCE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;ACCJ;ADAI;EANF;IAOI,eAAA;IACA,iBAAA;ECGJ;AACF;ADAE;EACE;IACE,uBAAA;ECEJ;EDAE;IACE,yBAAA;ECEJ;AACF;ADCE;EACE,YAAA;EACA,aAAA;EACA,6DAAA;ACCJ;ADCI;EACE,WAAA;EACA,YAAA;ACCN;ADGE;EACE,wCAAA;EACA,mBAAA;ACDJ;ADIE;EACE;IACE,YAAA;IACA,aAAA;ECFJ;AACF","sourcesContent":[".about {\n  padding: 20px;\n  max-width: 1250px;\n  margin: 0 auto;\n\n  h2 {\n    font-size: 32px;\n    line-height: 38px;\n    font-weight: 600;\n    text-align: center;\n    color: #ffffff;\n    @media (min-width: 495px) {\n      font-size: 48px;\n      line-height: 72px;\n    }\n  }\n\n  @keyframes rotate360 {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n\n  & .imgCard {\n    width: 300px;\n    height: 250px;\n    background: linear-gradient(180deg, #1b242b 0%, #171c1f 100%);\n\n    img {\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  .rotate img {\n    animation: rotate360 50s linear infinite;\n    animation-delay: 2s;\n  }\n\n  @media (min-width: 992px) {\n    & .imgCard {\n      width: 398px;\n      height: 432px;\n    }\n  }\n}\n",".about {\n  padding: 20px;\n  max-width: 1250px;\n  margin: 0 auto;\n}\n.about h2 {\n  font-size: 32px;\n  line-height: 38px;\n  font-weight: 600;\n  text-align: center;\n  color: #ffffff;\n}\n@media (min-width: 495px) {\n  .about h2 {\n    font-size: 48px;\n    line-height: 72px;\n  }\n}\n@keyframes rotate360 {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.about .imgCard {\n  width: 300px;\n  height: 250px;\n  background: linear-gradient(180deg, #1b242b 0%, #171c1f 100%);\n}\n.about .imgCard img {\n  width: 100%;\n  height: 100%;\n}\n.about .rotate img {\n  animation: rotate360 50s linear infinite;\n  animation-delay: 2s;\n}\n@media (min-width: 992px) {\n  .about .imgCard {\n    width: 398px;\n    height: 432px;\n  }\n} /*# sourceMappingURL=about.css.map */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
